import styled from 'styled-components';

interface DividerProps {
    direction?: 'horizontal' | 'vertical';
    verticalOffset?: string;
    color?: string;
}

const Divider = styled.hr<DividerProps>`
    border: none;

    border-top: 1px solid
        ${({ theme, color }) => color || theme.colors.primary[1600]};
    margin: ${({ verticalOffset }) => verticalOffset || '20px'} 0;
    ${({ direction, color, theme }) =>
        direction === 'vertical'
            ? `
        width: 1px;
        height: 83%;
        margin: 0 20px;
        border: none;
        border-left: 2px solid ${color || theme.colors.primary[1600]};
      `
            : `
        width: 100%;
        height: 1px;
      `}
`;

export default Divider;
